import { CONFIG, tapInSms } from "@/config";
import { Instagram, MessageSquare } from "lucide-react";

// Primary TAP IN CTA — deep-links to Instagram DM, with SMS fallback link.
export default function TapInButton({ label = "TAP IN", context = "", full = false, testid = "tap-in-btn" }) {
  const dm = CONFIG.instagramDM;
  const sms = tapInSms(context ? `Yo — I want to TAP IN on ${context}.` : "");
  return (
    <div className={`flex items-center gap-3 ${full ? "w-full" : ""}`}>
      <a
        href={dm}
        target="_blank"
        rel="noreferrer"
        data-testid={testid}
        className={`group inline-flex items-center justify-center gap-2 rounded-none bg-yaza-accent px-6 py-3 text-xs font-bold uppercase tracking-[0.2em] text-black transition-colors duration-200 hover:bg-yaza-accentHover ${
          full ? "flex-1" : ""
        }`}
      >
        <Instagram size={16} />
        {label}
      </a>
      <a
        href={sms}
        data-testid={`${testid}-sms`}
        aria-label="Text us"
        className="inline-flex h-11 w-11 items-center justify-center rounded-none border border-white/30 text-white transition-colors hover:border-yaza-accent hover:text-yaza-accent"
      >
        <MessageSquare size={16} />
      </a>
    </div>
  );
}
